<template>
  <div>
    <generic-container
      :title="$t('distribution revision')"
      icon="eye"
      :header_buttons="header_buttons"
    >
      <h2 class="ui dividing header">
        <i class="school icon"></i>
        <div class="content">
          {{ assignation.name }}
          <div class="sub header">
            {{ $t("from") }}
            <strong>{{
              assignation.start_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
            {{ $t("to") }}
            <strong>{{
              assignation.end_date
                | formatDate(enterprise_setup.simple_date_format)
            }}</strong>
          </div>
        </div>
      </h2>
      <course-based :assignation="assignation" v-if="method == 'course'" />
      <teacher-based :assignation="assignation" v-if="method == 'teacher'" />
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import {
  local_api,
  error_toast,
  success_toast,
  enterprise_setup,
} from "@/utils";
import CourseBased from "./course_based/Index";
import TeacherBased from "./teacher_based/Index";

// @ is an alias to /src
export default {
  name: "CourseAssignationRevisionIndex",
  components: {
    "generic-container": GenericContainer,
    CourseBased,
    TeacherBased,
  },
  filters: filters,
  data() {
    return {
      assignation: { setup: {} },
      header_buttons: [
        {
          icon: "refresh",
          tooltip: this.$t("refresh"),
          click: this.init,
        },
        {
          icon: "blue save",
          tooltip: this.$t("save all"),
          click: this.save,
        },
      ],
      method: "",
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    init() {
      let vm = this;
      let distribution_uuid = this.$route.query.i;
      if (distribution_uuid) {
        local_api(vm, "post", "/course/revision/do-get-season", {
          u: distribution_uuid,
        })
          .then((assignation) => {
            vm.assignation = assignation;
          })
          .catch((err) => {
            error_toast(err);
          });
      } else {
        error_toast(this.$t("no course distribution found"));
      }
    },
    save() {
      let vm = this;
      local_api(vm, "post", "/course/revision/do-save", {
        s: vm.assignation.uuid,
      })
        .then((/* assignation */) => {
          success_toast(vm.$t("all sections were created"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    getConfig() {
      let vm = this;
      vm.init();
      /**
       * Get course assignation module configuration
       */
      local_api(vm, "post", "/course/assignation/do-get-configuration", {})
        .then((r) => {
          if (r && r.conf && r.conf.setup) {
            if (r.conf.setup.method) {
              vm.method = r.conf.setup.method;
            }
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();
    vm.getConfig();
  },
  watch: {},
};
</script>
